module.exports = __webpack_public_path__ + "img/logo.3901b153.svg";